import React, {FC} from "react"

import FormattedMessage from "@irati/utils/lang"

import {StyledTab, StyledTabs} from "./styled"
import {SelectedTab} from "./types"

interface Props {
  currentTab: SelectedTab
  isPreview: boolean
  setTab: (tab: SelectedTab) => void
}

const CompanyNewsContentHeader: FC<Props> = ({currentTab, isPreview, setTab}) => (
  <StyledTabs>
    <StyledTab
      onClick={() => {
        if (!isPreview) {
          setTab(SelectedTab.IMAGE)
        }
      }}
      isActive={currentTab === SelectedTab.IMAGE}>
      <FormattedMessage id="platform.homepage.companyNews.newContent.image.title" />
    </StyledTab>
    <StyledTab
      onClick={() => {
        if (!isPreview) {
          setTab(SelectedTab.VIDEO)
        }
      }}
      isActive={currentTab === SelectedTab.VIDEO}>
      <FormattedMessage id="platform.homepage.companyNews.newContent.video.title" />
    </StyledTab>
    <StyledTab
      onClick={() => {
        if (!isPreview) {
          setTab(SelectedTab.TEMPLATE)
        }
      }}
      isActive={currentTab === SelectedTab.TEMPLATE}>
      <FormattedMessage id="platform.homepage.companyNews.newContent.template.title" />
    </StyledTab>
  </StyledTabs>
)

export default CompanyNewsContentHeader
